<template>
  <vs-sidebar position-right click-not-close parent="body" default-index="1"  color="primary" class="sidebarx" spacer v-model="isSidebarActiveLocal">
    <div class="web-camera-container">
      <div class="camera-button">
        <vs-button type="gradient" :color="!isCameraOpen ? 'success' :  'danger'" @click="toggleCamera">
          <span v-if="!isCameraOpen">Open Camera</span>
          <span v-else>Close Camera</span>
        </vs-button>
      </div>

      <div v-show="isCameraOpen && isLoading" class="camera-loading">
        <ul class="loader-circle">
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>

      <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">

        <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>

        <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>

        <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
      </div>

      <div v-if="isCameraOpen && !isLoading && !isPhotoTaken" class="camera-shoot">
        <button type="button" class="button" @click="takePhoto">
          <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
        </button>
      </div>

      <div v-if="isPhotoTaken && isCameraOpen" class="camera-download mt-5">
        <vs-button type="gradient" color="success" @click="save">Enregistrer</vs-button>
        <vs-button type="gradient" color="danger" class="ml-2" @click="cancel">Annuler</vs-button>
      </div>
    </div>
  </vs-sidebar>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    intervention_id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: '#'
    }
  },
  components: {
    
  },

  methods: {
     ...mapActions('interventions', {'addImage':'addImage'}),

    successMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },

    errorMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },

    toggleCamera() {
      if(this.isCameraOpen) {
        this.$emit('closeSidebar')
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;

      const constraints = (window.constraints = {
				audio: false,
				video: this.$isMobile() ? { facingMode: 'environment' } : true
			});


			navigator.mediaDevices
				.getUserMedia(constraints)
				.then(stream => {
          this.isLoading = false;
					this.$refs.camera.srcObject = stream;
				})
				.catch(error => {
          this.isLoading = false;
					alert("May the browser didn't support or there is some errors.");
				});
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

			tracks.forEach(track => {
				track.stop();
			});
    },

    takePhoto() {
      if(!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
    },

    cancel() {
      this.isPhotoTaken = false
    },

    save() {
      var obj = {
        image : document.getElementById("photoTaken").toDataURL("image/jpeg"),
        id: this.intervention_id
      }

      this.addImage(obj).then(result => {
        this.$emit('closeSidebar')
        this.$emit('addImage', result.data)
        this.successMsg("L'ajout","Le photo est bien ajouté");
      }).catch(() => {
        this.$emit('closeSidebar')
        this.errorMsg('L\'Ajout','Trouvé un error lor de l\'insertion')
      })
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          this.initValues(true)
        }
      },
    }
  },

  watch: {
     isSidebarActiveLocal (val) {
       if(val) this.toggleCamera()
     }
  }

}
</script>

<style lang="scss" scoped>
  body {
  display: flex;
  justify-content: center;
}

.web-camera-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;


  .camera-button {
    margin-bottom: 2rem;
  }

  .camera-box {
    .camera-shutter {
      opacity: 0;
      width: 450px;
      height: 337.5px;
      background-color: #fff;
      position: absolute;

      &.flash {
        opacity: 1;
      }
    }

    video, canvas {
      width: 100% !important;
    }
  }

  .camera-shoot {
    margin: 1rem 0;

    button {
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;

      img {
        height: 35px;
        object-fit: cover;
      }
    }
  }

  .camera-loading {
    overflow: hidden;
    height: 100%;
    position: absolute;
    width: 100%;
    min-height: 150px;
    margin: 3rem 0 0 -1.2rem;

    ul {
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 999999;
      margin: 0;
    }

    .loader-circle {
      display: block;
      height: 14px;
      margin: 0 auto;
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      transform: translateX(-56%);
      position: absolute;
      width: 100%;
      padding: 0;

      li {
        display: block;
        float: left;
        width: 10px;
        height: 10px;
        line-height: 10px;
        padding: 0;
        position: relative;
        margin: 0 0 0 4px;
        background: #999;
        animation: preload 1s infinite;
        top: -50%;
        border-radius: 100%;

        &:nth-child(2) {
          animation-delay: .2s;
        }

        &:nth-child(3) {
          animation-delay: .4s;
        }
      }
    }
  }

  @keyframes preload {
    0% {
      opacity: 1
    }
    50% {
      opacity: .4
    }
    100% {
      opacity: 1
    }
  }
}
</style>
